export default __webpack_public_path__ + "static/media/mode-11.85ab73cc.svg";